;jQuery(document).ready(function ($) {
    "use strict"

    // Browser Windows Sizes
    const browser = {
        w: document.documentElement.clientWidth,
        h: document.documentElement.clientHeight,
    }

    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    $(window).on('resize orientationchange', () => {
        browser.w = document.documentElement.clientWidth
        browser.h = document.documentElement.clientHeight

        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
    });

    function setCookie(name, value, days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    /* ----------------------------------- Scrollbar CSS Variable ------------------------------------ */
    {
        const getScrollbarWidth = () => {
            let outer = document.createElement("div");
            outer.style.visibility = "hidden";
            outer.style.width = "100px";
            outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

            document.body.appendChild(outer);

            let widthNoScroll = outer.offsetWidth;
            // force scrollbars
            outer.style.overflow = "scroll";

            // add innerdiv
            let inner = document.createElement("div");
            inner.style.width = "100%";
            outer.appendChild(inner);

            let widthWithScroll = inner.offsetWidth;

            // remove divs
            outer.parentNode.removeChild(outer);

            return widthNoScroll - widthWithScroll;
        }
        if ($('body').outerHeight() <= document.documentElement.clientHeight) {
            document.documentElement.style.setProperty('--scroll-width', 0);
        } else {
            document.documentElement.style.setProperty('--scroll-width', getScrollbarWidth() + 'px');
        }
    }

    /* ----------------------------------- Page Header Height Fix ------------------------------------ */
    {
        function setHeaderHeight() {
            if (browser.w > 991 && $('.page-header').length) {
                const pageHeaderH = $('.page-header').outerHeight();
                const formH = $('.page-header__over .col-right').outerHeight();
                $('.page-header').parents('.page-header__wrapper').next('.page-content-section').css({
                    'min-height': `${formH - pageHeaderH + 70}px`
                })
            }
        }

        setHeaderHeight();

        $(window).on('resize orientationchange', function () {
            setHeaderHeight();
        })
    }

    /* ----------------------------------- Mobile Navigation ------------------------------------ */
    {
        $(document).on('click', '.nav-main__toggle', function (e) {
            e.preventDefault()
            $('.nav-side').addClass('active')
            scrollLock.disablePageScroll()
        })

        // Close
        $(document).on('click', '.nav-side__close', function (e) {
            e.preventDefault()
            $('.nav-side').removeClass('active')
            scrollLock.enablePageScroll()
        })

        // Add Arrows
        $('.nav-side .menu li.menu-item-has-children > a').append(`
            <span class="sub-menu-toggle">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 256 256" style="enable-background:new 0 0 256 256;" xml:space="preserve">
                          <polygon points="225.813,48.907 128,146.72 30.187,48.907 0,79.093 128,207.093 256,79.093 \t\t"/> 
                </svg>
            </span>
        `)

        // Nav Mobile Accordions
        $('.nav-side .menu .menu-item-has-children .sub-menu-toggle').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).parents('a').eq(0).siblings('.sub-menu').slideToggle('fast');
        })
    }

    /* ----------------------------------- Fixed Navigation ------------------------------------ */
    {
        /*const nav = $('.nav-main');
        const navFixed = nav.clone().addClass('fixed').insertAfter(nav);
        let lastScroll = 0;
        $(window).on('scroll', function () {
            const scroll = $(this).scrollTop();
            if (scroll >= 450) {
                navFixed.addClass('active');
            } else {
                navFixed.removeClass('active');
                navFixed.find('.lang-list').removeClass('active');
            }
            lastScroll = scroll;
        });*/
    }

    /* ----------------------------------- Navigation Search ------------------------------------ */
    {
        $('.nav-main__search-toggle').on('click', function (e) {
            e.preventDefault();
            $('.nav-main__search').addClass('active');
        });
        $('.nav-main__search-close').on('click', function (e) {
            e.preventDefault();
            $('.nav-main__search').removeClass('active');
        });
    }

    /* ----------------------------------- Cookie Banner ------------------------------------ */
    {
        if (getCookie('GCC') !== 'Accepted all cookies') {
            setTimeout(() => {
                $('.cookie-banner').addClass('active');
            }, 1000);

            $('.btn-cookie-accept').on('click', function (e) {
                e.preventDefault();
                $('.cookie-banner').removeClass('active');
                setCookie('GCC', 'Accepted all cookies', 14);
            });
        }


    }

    /* ----------------------------------- Anchors ------------------------------------ */
    {
        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();

            const href = $(this).attr('href');

            if (!(href === '#')) {

                const section = $(href);

                if (section.length) {
                    const offset = $(section).offset().top;
                    $('html,body').animate({
                        scrollTop: offset
                    }, 600);
                }

            } else {
                return false
            }

        });
    }


    /* ----------------------------------- Trusted By Slider ------------------------------------ */
    {
        if (browser.w <= 1199) {
            const swiper = new Swiper('.partners-slider', {
                direction: 'horizontal',
                loop: true,
                slidesPerView: 'auto',
            });
        }
    }

    /* ----------------------------------- Service Areas Slider ------------------------------------ */
    {
        if (browser.w <= 991) {
            const swiper = new Swiper('.service-areas-slider', {
                direction: 'horizontal',
                loop: true,
                slidesPerView: 'auto',
                centeredSlides: true,
                autoHeight: true
            });
        }
    }

    /* ----------------------------------- Testimonials Slider ------------------------------------ */
    {
        if ($('.testimonials-slider').length) {
            $('.testimonials-slider').each(function () {
                const slider = $(this);
                const sliderSwiper = new Swiper(slider[0], {
                    direction: 'horizontal',
                    loop: true,
                    slidesPerView: 'auto',
                    grabCursor: true,
                });

                slider.parents('.testimonials-slider__wrapper').eq(0).find('.testimonials-slider__prev').on('click', function (e) {
                    e.preventDefault();
                    sliderSwiper.slidePrev()
                })

                slider.parents('.testimonials-slider__wrapper').eq(0).find('.testimonials-slider__next').on('click', function (e) {
                    e.preventDefault();
                    sliderSwiper.slideNext()
                })

            });
        }
    }

    /* ----------------------------------- Related Posts Slider ------------------------------------ */
    {
        if ($('.rp-slider').length) {
            $('.rp-slider').each(function () {
                const slider = $(this);
                const sliderSwiper = new Swiper(slider[0], {
                    direction: 'horizontal',
                    loop: true,
                    slidesPerView: 'auto',
                    grabCursor: true,
                });

                slider.parents('.rp-slider__wrapper').eq(0).find('.rp-slider__prev').on('click', function (e) {
                    e.preventDefault();
                    sliderSwiper.slidePrev()
                })

                slider.parents('.rp-slider__wrapper').eq(0).find('.rp-slider__next').on('click', function (e) {
                    e.preventDefault();
                    sliderSwiper.slideNext()
                })

            });
        }
    }

    /* ----------------------------------- Team Slider ------------------------------------ */
    {
        if ($('.team-slider').length) {
            $('.team-slider').each(function () {
                const slider = $(this);
                const sliderSwiper = new Swiper(slider[0], {
                    direction: 'horizontal',
                    loop: true,
                    slidesPerView: 'auto',
                    grabCursor: true,
                });

                slider.parents('.team-slider__wrapper').eq(0).find('.team-slider__prev').on('click', function (e) {
                    e.preventDefault();
                    sliderSwiper.slidePrev()
                })

                slider.parents('.team-slider__wrapper').eq(0).find('.team-slider__next').on('click', function (e) {
                    e.preventDefault();
                    sliderSwiper.slideNext()
                })

            });
        }
    }

    /* ----------------------------------- Accordion ------------------------------------ */
    {
        $('.acc-item').each(function () {
            const header = $(this).find('.acc-item__header');
            const answer = $(this).find('.acc-item__answer');

            header.on('click', function () {
                answer.slideToggle('fast');
                $(this).parents('.acc-item').toggleClass('active');
            });

        })
    }

    /* ----------------------------------- Scroll To Top ------------------------------------ */
    {
        $('.scroll-to-top').on('click', function (e) {
            e.preventDefault();

            $('html,body').animate({
                scrollTop: 0
            }, 600);

        })
    }

    /* ----------------------------------- Blog Load More ------------------------------------ */
    {
        $('.blog-load-more').click(function () {
            var button = $(this),
                data = {
                    'action': 'blog_load_more',
                    'query': PHP.posts,
                    'page': PHP.current_page
                };

            $.ajax({
                url: PHP.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function (xhr) {
                    $('.body').addClass('wait');
                },
                success: function (data) {
                    if (data) {
                        $(data).appendTo('.posts-list').hide().fadeIn('fast');
                        PHP.current_page++;
                        if (PHP.current_page == PHP.max_page)
                            $('.posts-pagination').remove();
                    } else {
                        $('.posts-pagination').remove();
                    }

                    $('.body').removeClass('wait');
                }
            });
        });
    }

    /* ----------------------------------- Form Elements ------------------------------------ */
    {
        // Input
        $('.input').each(function () {
            if ($(this).val().length > 1) {
                $(this).parents('.input-label').addClass('focus');
            }
        });
        $('.input').on('focus', function () {
            $(this).parents('.input-label').addClass('focus');
        });
        $('.input').on('blur', function () {
            const val = $(this).val()
            $(this).val(val.trim())

            if ($(this).val().length >= 1) {
                $(this).parents('.input-label').addClass('focus');
                $(this).parents('.form-group').find('.wpcf7-not-valid-tip').remove();
            } else {
                $(this).parents('.input-label').removeClass('focus');
            }
        });

        // Textarea
        $('.textarea').each(function () {
            if ($(this).val().length > 1) {
                $(this).parents('.textarea-label').addClass('focus');
            }
        });
        $('.textarea').on('focus', function () {
            $(this).parents('.textarea-label').addClass('focus');
        });
        $('.textarea').on('blur', function () {
            const val = $(this).val()
            $(this).val(val.trim())

            if ($(this).val().length >= 1) {
                $(this).parents('.textarea-label').addClass('focus');
                $(this).parents('.form-group').find('.wpcf7-not-valid-tip').remove();
            } else {
                $(this).parents('.textarea-label').removeClass('focus');
            }
        });

        // Select
        if ($('.select').length) {
            $('.select').each(function () {
                const current = $(this);

                current.prepend(`<option value="" disabled="" selected=""></option>`);

                current.selectric({
                    disableOnMobile: false,
                    nativeOnMobile: false,
                    onChange: function (element) {
                        if ($(element).val() && $(element).val() != '') {
                            current.parents('.select-wrap').addClass('active');
                            current.parents('.form-group').find('.wpcf7-not-valid-tip').remove();
                        } else {
                            current.parents('.select-wrap').removeClass('active');
                        }
                    },
                });

            });
        }

        // Phone Input
        $('input[type="tel"]').on('input', function () {
            if (/\D/g.test(this.value)) {
                // Filter non-digits from input value.
                this.value = this.value.replace(/\D/g, '');
            }
        })
    }

    /* ----------------------------------- Contact Form ------------------------------------ */
    {
        var wpcf7Elm = document.querySelector('.wpcf7');
        if (wpcf7Elm) {

            wpcf7Elm.addEventListener('wpcf7beforesubmit', function (event) {
                $('body').addClass('wait');
            }, false);

            wpcf7Elm.addEventListener('wpcf7invalid', function (event) {
                $('body').removeClass('wait');
            }, false);

            wpcf7Elm.addEventListener('wpcf7submit', function (event) {
                $('body').removeClass('wait');
            }, false)

            wpcf7Elm.addEventListener('wpcf7mailsent', function (event) {
                Swal.fire({
                    icon: 'success',
                    title: PHP.cf_success_notification.title,
                    text: PHP.cf_success_notification.text,
                    confirmButtonText: PHP.cf_success_notification.btn_text
                });
                $('body').removeClass('wait');


                setTimeout(() => {
                    location.href = 'https://www.gccfm.com/contact/thank-you/';
                }, 350);
            }, false);

            wpcf7Elm.addEventListener('wpcf7mailfailed', function (event) {
                Swal.fire({
                    icon: 'error',
                    title: PHP.cf_error_notification.title,
                    text: PHP.cf_error_notification.text,
                    confirmButtonText: PHP.cf_error_notification.btn_text
                });

                $('body').removeClass('wait');

            }, false);

        }


        
        function pullHiddenField() {
            $('.wpcf7-form-control').each(function () {
                const name = $(this).attr('name')
                const param = new URLSearchParams(window.location.search).get(name);
                if (param) {
                    $(this).val(param)
                }
            })
        }

        pullHiddenField()

        window.onload = function () {
            $('.form').removeClass('blocked')
            pullHiddenField()
        }
    }


});

